import client from "./client";

export default {

    async getVendorCategories(filters) {
        return client.parseResponse(await client.get('/vendor-categories', filters));
    },
    async getVendorCategory(id) {
        return client.parseResponse(await client.get('/vendor-categories/' + id));
    },
    async createVendorCategory(data) {
        return client.parseResponse(await client.post('/vendor-categories', data))
    },
    async editVendorCategory(data) {
        return client.parseResponse(await client.put('/vendor-categories/' + data.id, data))
    },
    async deleteVendorCategory(data) {
        return client.parseResponse(await client.delete('/vendor-categories/' + data.id, data))
    }
}
